import keys from '@debbie/common/dist/cache/keys.js';
import { Site } from '@debbie/common/dist/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as workflowsAPI from '@debbie/cortex/dist/api/workflows.js';
import { h } from '@debbie/cortex/dist/index.js';
import q from '@debbie/cortex/dist/query.js';
import { useUpdateTypesMap } from '@debbie/cortex/dist/update-types/index.js';
import { updatesEntity } from '@debbie/cortex/dist/updates/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { errorNotification } from '../../utils/errors.js';
import Button from '../Button.js';
const TaskButtons = (props) => {
    const updateTypesMapLoadable = useUpdateTypesMap();
    const updateTypesMap = h.hasData(updateTypesMapLoadable)
        ? updateTypesMapLoadable.data
        : {};
    const { tasks, case: _case } = props;
    return (React.createElement(React.Fragment, null, tasks.map((task) => {
        const updateType = updateTypesMap[task.updateTypeId];
        if (!updateType) {
            return null;
        }
        return (React.createElement(TaskButton, { key: task.id, updateType: updateType, case: _case, task: task }));
    })));
};
const TaskButton = (props) => {
    const { updateType, case: _case, task } = props;
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const runTaskMutation = useMutation(async () => {
        if (_case.workflowId) {
            await workflowsAPI.runTask(_case.workflowId, _case.caseId, task.id);
            q.invalidate(keys.write.create(updatesEntity));
        }
    }, {
        onError: (err) => {
            errorNotification(lang, err, 'any', lang.errorEntities.task);
        },
    });
    if (Site.Client == site &&
        updateType.responsiblePermissionLevel != 'client') {
        return null;
    }
    return (React.createElement(Button, { blockOnMobile: true, size: "small", loading: runTaskMutation.isLoading, onClick: () => {
            runTaskMutation.mutate();
        } }, lang.updateTypes[updateType.updateTypeId] || updateType.label));
};
export default TaskButtons;
//# sourceMappingURL=TaskButtons.js.map